import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "template-list" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-title" }
const _hoisted_4 = { class: "header-segmented" }
const _hoisted_5 = { class: "segment-item" }
const _hoisted_6 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_7 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_8 = ["infinite-scroll-disabled"]
const _hoisted_9 = { class: "template-item" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "template-mask" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "template-name" }
const _hoisted_14 = {
  key: 3,
  class: "loading"
}
const _hoisted_15 = {
  key: 4,
  class: "no-more"
}

import { ref, onMounted } from 'vue';
import { fetchTemplates, ITemplate, fetchCollect } from '../common';



export default /*@__PURE__*/_defineComponent({
  __name: 'TemplateList',
  props: {
  title: {
    type: String,
    default: '从选择模板开始创建视频',
  },
},
  emits: ['selectTemplate'],
  setup(__props, { emit: __emit }) {

const props = __props;

const resolution = ref('1080x1920'); // 分辨率
const options = ref([
  { label: '竖屏', value: '1080x1920', icon: 'ri-layout-bottom-2-line' },
  { label: '横屏', value: '1920x1080', icon: 'ri-layout-left-2-line' },
]); // 分辨率选项
const pageNum = ref(1); // 当前页码
const pageSize = ref(resolution.value === '1080x1920' ? 16 : 12); // 根据分辨率设置每页条数
const total = ref(0); // 总条数
const templates = ref<ITemplate[]>([]); // 模板列表
const loading = ref(false); // 加载状态
const finished = ref(false); // 是否加载完成
const hasError = ref(false); // 是否有错误

const emit = __emit;

// 选择模板
const selectTemplate = (template) => {
  emit('selectTemplate', template);
};

// 处理分辨率变化
const handleResolutionChange = () => {
  console.log('触发resolutionChange');
  console.log('resolution', resolution.value);
  refreshTemplates();
};

// 刷新模板列表
const refreshTemplates = () => {
  pageNum.value = 1;
  templates.value = [];
  finished.value = false;
  hasError.value = false;
  pageSize.value = resolution.value === '1080x1920' ? 18 : 12;
  getTemplates();
};

// 获取模板列表
const getTemplates = async () => {
  loading.value = true;
  hasError.value = false;

  try {
    // 封装请求参数
    const params = {
      pageIndex: pageNum.value,
      pageSize: pageSize.value,
      belong: 1,
      resolution: resolution.value,
    };
    const { data: res } = await fetchTemplates(params);
    if (res && res.data) {
      templates.value = [...templates.value, ...res.data.list];
      total.value = res.data.total || 0;
      pageNum.value++;
      // 判断是否已加载完所有数据
      if (templates.value.length >= total.value) {
        finished.value = true;
      }
    } else {
      finished.value = true;
    }
  } catch (error) {
    console.error(error);
    hasError.value = true;
    finished.value = true;
  } finally {
    loading.value = false;
  }
};

// 收藏
const collectTemplate = async (template) => {
  try {
    await fetchCollect({
      businessId: template.id,
      type: 3,
    });
    template.isCollect = template.isCollect == 1 ? 0 : 1;
  } catch (error) {
    console.error(error);
  }
};

// 加载更多
const load = async () => {
  if (loading.value || finished.value || hasError.value) return;
  loading.value = true;
  try {
    console.log('触发load');
    await getTemplates();
  } catch (error) {
    console.error(error);
    hasError.value = true;
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  refreshTemplates();
});

return (_ctx: any,_cache: any) => {
  const _component_el_segmented = _resolveComponent("el-segmented")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(props.title), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_segmented, {
          modelValue: resolution.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((resolution).value = $event)),
          options: options.value,
          onChange: handleResolutionChange
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("i", {
                class: _normalizeClass(scope.item.icon)
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(scope.item.label), 1)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "options"])
      ])
    ]),
    _createVNode(_component_el_scrollbar, { style: {"padding":"12px"} }, {
      default: _withCtx(() => [
        (hasError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "ri-error-warning-line empty-icon" }, null, -1)),
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "empty-text" }, "加载失败，请重试", -1)),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: refreshTemplates,
                loading: loading.value
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("i", { class: "ri-refresh-line" }, null, -1),
                  _createTextVNode(" 刷新 ")
                ])),
                _: 1
              }, 8, ["loading"])
            ]))
          : (templates.value.length === 0 && !loading.value && !hasError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "ri-file-list-3-line empty-icon" }, null, -1)),
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "empty-text" }, "暂无模板数据", -1)),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: refreshTemplates,
                  loading: loading.value
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createElementVNode("i", { class: "ri-refresh-line" }, null, -1),
                    _createTextVNode(" 刷新 ")
                  ])),
                  _: 1
                }, 8, ["loading"])
              ]))
            : _withDirectives((_openBlock(), _createElementBlock("div", {
                key: 2,
                "infinite-scroll-disabled": loading.value || hasError.value,
                "infinite-scroll-distance": "10",
                "infinite-scroll-immediate": false,
                class: "template-container"
              }, [
                _createVNode(_component_el_row, { gutter: 15 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templates.value, (template, index) => {
                      return (_openBlock(), _createBlock(_component_el_col, {
                        key: index,
                        xs: 12,
                        sm: resolution.value === '1080x1920' ? 8 : 12,
                        md: resolution.value === '1080x1920' ? 6 : 8,
                        lg: resolution.value === '1080x1920' ? 6 : 8,
                        xl: resolution.value === '1080x1920' ? 6 : 8,
                        class: "template-col"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["template-cover", { 'vertical': resolution.value === '1080x1920', 'horizontal': resolution.value === '1920x1080' }])
                            }, [
                              _createElementVNode("img", {
                                src: template.coverUrl,
                                alt: template.name
                              }, null, 8, _hoisted_10),
                              _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  class: "create-btn",
                                  onClick: ($event: any) => (selectTemplate(template))
                                }, {
                                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                                    _createElementVNode("i", { class: "ri-video-add-line" }, null, -1),
                                    _createTextVNode(" 创建视频 ")
                                  ])),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["collect-btn", template.isCollect ? 'primary' : 'default']),
                                  onClick: _withModifiers(($event: any) => (collectTemplate(template)), ["stop"])
                                }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(template.isCollect ? 'ri-heart-fill' : 'ri-heart-line')
                                  }, null, 2)
                                ], 10, _hoisted_12)
                              ])
                            ], 2),
                            _createElementVNode("div", _hoisted_13, _toDisplayString(template.name), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["sm", "md", "lg", "xl"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ], 8, _hoisted_8)), [
                [_directive_infinite_scroll, load]
              ]),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, " 加载中... "))
          : _createCommentVNode("", true),
        (finished.value && !loading.value && !hasError.value && templates.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, " 没有更多数据了 "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})